<template>
  <dv-border-box-7 class="statistic" :color="['rgba(6,19,34,0.4)', 'rgba(6,19,34,0.5)']">
    <dl v-for="(item,index) in items" :key="index">
      <dt>{{item.title}}</dt>
      <dd><b>{{item.data}}</b>{{item.unit}}</dd>
    </dl>
  </dv-border-box-7>
</template>

<script>
export default {
  name: 'Statistic',
  props: {
    items: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {};
  },
  created() {

  },
  mounted() {

  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.statistic {
  width: 100%;
  height: 80px;
  display: flex;
  flex-direction: row;
  align-items: center;
  color: #ffffff;
  position: relative;
  z-index: 2;
  dl {
    font-size: 15px;
    dd {
      b {
        font-size: 20px;
        padding-right: 6px;
      }
    }
  }
}

::v-deep .border-box-content {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
}
</style>
